module.exports = __webpack_public_path__ + "media/images/btn_new_booking-28b0daa0dad99feee72c65394c607c35.gif";